import {GPItem} from "./gp-item.js";
import {GPProjectView} from "./gp-projectview.js";
import {fontSize} from "./gp-context-labels";

export class GPLabel extends GPItem
{
    constructor (id, text, x, y, originItemInstance ) {
        super();
        this.id = id;
        this.text = text;
        this.x = x;
        this.y = y;
        this.actualBaseOffset = 0;
        this.originItemInstance = originItemInstance;
        this.fixedObject = false;

        this.supportsFlip = false;
        this.supportsInfo = false;
        this.supportsAdjust = false;
        this.supportsRotate = false;
    };

    getName () {
        return this.text;
    }
    
    itemImageScale () {
        return 1;
    }

    //Below go the methods for view (should be on associated view object, but for now are merged here)

    createDisplayObject () {
        var that = this;
        return new Promise(function(resolve, reject) {
            var simpleLabel = new Konva.Label({
                draggable: true,
                id: String(that.id)
            });

            simpleLabel.add(
                new Konva.Tag({
                    fill: '#eeeeee',
                    opacity: 0.7,
                    id: 'tag_' + String(that.id)
                })
            );
            simpleLabel.add(
                new Konva.Text({
                    text: that.text,
                    fontFamily: 'gpfont_semibold',
                    fontSize: fontSize,
                    padding: 3,
                    fill: 'black',
                    id: 'text_' + String(that.id)
                })
            );
            resolve(simpleLabel);
        });
    }

    repositionItem () {
        var ko = GPProjectView.stage.find('#' + this.id)[0];
        if (!ko) return;

        var v = GPProjectView.coordsProjectToView(this.x, this.y);
        var vi = GPProjectView.coordsViewToImagePos(this.x, this.y, v.x, v.y, ko.getWidth()/GPProjectView.sceneScale * 1024 / GP.project.sizeX, ko.getHeight()/GPProjectView.sceneScale * 1024 / GP.project.sizeX, this);

        ko.setX(vi.x);
        ko.setY(vi.y);
    }

    setHighlight (state) {
        var id = this.id;

        GPProjectView.stage.find('#' + id).forEach(function (el) {
            if (Reflect.getPrototypeOf(el).className === "Tag") {
                el.opacity(state ? 1 : 0.7);
                el.cache();
                el.drawHitFromCache();
            }
        });
    }
    
    toJSON() {
        return {
            id: this.id,
            x: this.x,
            y: this.y,
            t: this.text,
            o: this.originItemInstance.id
        }
    }
}
